import { TagGroupInfoFragment } from 'generated/graphql';

export function removeCategorgiesFromGroupsFn(tagCategoryIds: string[]) {

  return (groups: TagGroupInfoFragment[]) => {
    const newGroups = groups.map(g => {
      g.categories = g.categories.filter(c => !tagCategoryIds.includes(c.id));
      return g;
    });

    return newGroups.filter(g => g.categories.length > 0);
  };
}

